import React from "react";
import "./InfoPopup.css";

interface InfoPopupProps extends React.HTMLProps<HTMLDivElement> {
  position: "n" | "ne" | "e" | "se" | "s" | "sw" | "w" | "nw";
  id: string;
  triggerElement: React.ReactNode;
  classNameContainer?: string;
  classNameBox?: string;
  withArrow?: boolean;
  triggerAction?: "hover" | "click";
  onBlur?: () => void;
}

export const InfoPopup: React.FC<InfoPopupProps> = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);

  function iterateParentNodesAndCheckIfHasPropID(
    node: HTMLElement | null,
  ): boolean {
    let hasPropID = false;
    while (node) {
      if (node.id.includes(props.id)) {
        hasPropID = true;
        break;
      }
      node = node.parentElement;
    }

    return hasPropID;
  }

  class Class {
    static container() {
      const className = ["infoPopupContainer"];
      if (props.classNameContainer) className.push(props.classNameContainer);
      return className.join(" ");
    }

    static box() {
      const className = ["infoPopupBox"];
      if (props.classNameBox) className.push(props.classNameBox);
      if (props.position) className.push(`infoPopupPosition-${props.position}`);
      if (props.withArrow)
        className.push(`infoPopupWithArrow-${props.position}`);
      return className.join(" ");
    }
  }

  class Trigger {
    static hoverEnter() {
      const triggerAction = props.triggerAction || "hover";
      if (triggerAction !== "hover") {
        return;
      }

      setIsOpen(true);
    }

    static hoverLeave() {
      const triggerAction = props.triggerAction || "hover";
      if (triggerAction !== "hover") {
        return;
      }

      setIsOpen(false);
    }

    static click() {
      if (props.triggerAction !== "click") {
        return;
      }

      if (isOpen && props.onBlur) {
        props.onBlur();
      }

      setIsOpen(!isOpen);
    }

    static clickOutside(e: MouseEvent) {
      if (!iterateParentNodesAndCheckIfHasPropID(e.target as HTMLElement)) {
        if (props.onBlur) props.onBlur();
        setIsOpen(false);
      }
    }
  }

  React.useEffect(() => {
    if (props.triggerAction !== "click") return;
    document.addEventListener("click", Trigger.clickOutside);
    return () => document.removeEventListener("click", Trigger.clickOutside);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.triggerAction]);

  return (
    <div
      className={Class.container()}
      onMouseEnter={Trigger.hoverEnter}
      onMouseLeave={Trigger.hoverLeave}
      onClick={Trigger.click}
      id={props.id}
    >
      {props.triggerElement}
      {isOpen && (
        <div
          id={`${props.id}-infoPopupBox`}
          className={Class.box()}
          onClick={(e) => e.stopPropagation()}
        >
          {props.children}
        </div>
      )}
    </div>
  );
};
